<template>
    <div class="deposits-component">
        <div class="flex relative justify-center mt-8 mb-4 lg:my-12">
            <transition name="slide-fade" mode="out-in" appear>
                <v-btn
                    @click="back"
                    v-if="currentStep > 1 && currentStep < 5"
                    class="back-btn"
                    text
                    color="white"
                >
                    <span class="material-icons material-icons--arrow-left">
                        arrow_left
                    </span>
                    {{ $trans.get("deposits.back") }}
                </v-btn>
            </transition>
            <span
                class="step-circle inline-flex justify-center items-center"
                :class="[`step-${currentStep}`]"
            >
                {{ currentStep }}
            </span>
        </div>

        <h1 class="title white text-center mt-8">
            {{ $trans.get("deposits.mainTitle") }}
        </h1>

        <transition-group
            name="slide-fade"
            tag="div"
            class="steps relative"
        >
            <step-1
                v-if="currentStep === 1"
                v-bind:current-step.sync="currentStep"
                :permits="permits"
                :courses="courses"
                key="1"
            ></step-1>

            <step-2
                v-if="currentStep === 2"
                v-bind:current-step.sync="currentStep"
                key="2"
            ></step-2>

            <step-3
                v-if="currentStep === 3"
                v-bind:current-step.sync="currentStep"
                :title-selected="titleSelected"
                key="3"
            ></step-3>

            <step-4
                v-if="currentStep === 4"
                v-bind:current-step.sync="currentStep"
                :title-selected="titleSelected"
                key="4"
            ></step-4>

            <div v-if="currentStep === 5" key="5">
                <div
                    class="step step-5 flex flex-col lg:flex-row items-center lg:justify-center lg:items-start lg:flex-wrap w-full top-0 bottom-0"
                    v-if="!error"
                >
                    <div
                        class="w-full flex flex-col lg:flex-row justify-center"
                    >
                        <section class="w-full lg:w-1/3 lg:mr-4">
                            <h3 class="title text-center my-2">
                                {{ $trans.get("deposits.data") }}
                            </h3>
                            <div class="box bg-white w-full p-4 lg:p-8">
                                <p class="font-bold ">
                                    {{ $trans.get("deposits.name") }}:
                                    <span class="capitalize">{{
                                        deposit.name
                                    }}</span>
                                    <span>{{ deposit.surname }}</span>
                                </p>
                                <p class="font-bold mt-4">
                                    DNI:<span> {{ deposit.dni }}</span>
                                </p>
                                <p class="font-bold mt-4">
                                    {{ $trans.get("deposits.school") }}:<span>
                                        {{ deposit.school }}</span
                                    >
                                </p>
                                <p class="font-bold ">
                                    {{ $trans.get("deposits.permit-course") }}:
                                    <span>
                                        {{ deposit.depositable.name[lang] + ' ' + deposit.depositable.description[lang] }}
                                    </span>
                                </p>
                                <p class="font-bold mt-4">
                                    FUC del
                                    {{ $trans.get("deposits.business") }}:<span>
                                        335833604-1</span
                                    >
                                </p>
                                <p class="font-bold mt-4">
                                    {{ $trans.get("deposits.shopName") }}:<span>
                                        Autoescola Pallars (ESPAÑA)</span
                                    >
                                </p>
                                <p class="font-bold mt-4">
                                    URL del
                                    {{ $trans.get("deposits.business") }}:<span>
                                        https://www.autoescolapallars.com/</span
                                    >
                                </p>
                                <p class="font-bold mt-4">
                                    {{ $trans.get("deposits.idOrder") }}:<span>
                                        {{ gettersredsys.Ds_Order }}</span
                                    >
                                </p>
                                <p class="font-bold mt-4">
                                    {{ $trans.get("deposits.date") }}:<span>
                                        {{
                                            gettersredsys.Ds_Date.replace(
                                                /%2F/g,
                                                "/"
                                            )
                                        }}
                                        {{
                                            gettersredsys.Ds_Hour.replace(
                                                /%3A/g,
                                                ":"
                                            )
                                        }}</span
                                    >
                                </p>
                                <p class="font-bold mt-4">
                                    {{ $trans.get("deposits.idCode") }}:<span>
                                        {{
                                            gettersredsys.Ds_AuthorisationCode
                                        }}</span
                                    >
                                </p>
                            </div>
                        </section>

                        <section class="w-full lg:w-1/3 mt-10 lg:mt-0 lg:ml-4">
                            <div>
                                <h3 class="title text-center my-2">
                                    {{ $trans.get("deposits.purchaseSummary") }}
                                </h3>
                                <div
                                    class="box bg-white w-full p-3 md:px-48 lg:p-8"
                                >
                                    <p class="flex justify-between" v-if="deposit.title_amount">
                                        <span class="leading-tight pr-3">
                                            {{ $trans.get('deposits.step-2-options.title')}}
                                        </span>
                                        <span>{{ deposit.title_amount | currency }}</span>
                                    </p>
                                    <p class="flex justify-between" :class="{'mt-4': deposit.title_amount}"
                                        v-if="deposit.taxes_amount">
                                        <span class="leading-tight pr-3">
                                            {{ $trans.get('deposits.step-2-options.taxes')}}
                                        </span>
                                        <span>{{ deposit.taxes_amount | currency }}</span>
                                    </p>
                                    <p class="flex justify-between mt-4">
                                        <span class="font-bold">{{
                                            $trans.get("deposits.total")
                                        }}</span>
                                        <span class="font-bold"
                                            >{{ deposit.amount | currency }}</span
                                        >
                                    </p>
                                </div>
                                <div class="print-container">
                                    <v-btn
                                        onclick="window.print();return false;"
                                        class="print-button"
                                        >Imprimir</v-btn
                                    >
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div v-else class="text-center">
                    {{
                        lang === "es"
                            ? "No se ha podido realizar el pago"
                            : "No s'ha pogut efectuar el pagament"
                    }}
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";

export default {
    props: {
        stepProp: {
            type: Number,
            default: 1
        },
        deposit: {
            type: Object,
            default: () => {
                return {};
            }
        },
        gettersredsys: {
            type: Object,
            default: () => {
                return {};
            }
        },
        error: {
            type: Boolean,
            default: false
        },
        permits: {
            type: Array,
            default: () => []
        },
        courses: {
            type: Array,
            default: () => []
        }
    },
    components: {
        Step1,
        Step2,
        Step3,
        Step4
    },
    data() {
        return {
            currentStep: 1
        };
    },
    computed: {
        ...mapGetters(["validForm", "getFormData"]),
        titleSelected() {
            if (! this.getFormData.titleId) return '';
            const titleType =
                this.getFormData.titleType === "permit" ? "permits" : "courses";
            const { name, description } = this[titleType].find(
                t => t.id === this.getFormData.titleId
            );
            return `${name[this.lang]} ${description[this.lang]}`;
        }
    },

    filters: {
        currency: function(value) {
            return value.toString().replace(".", ",") + "€";
        }
    },

    methods: {
        ...mapActions(["loadResources"]),
        back() {
            this.currentStep--;
        }
    },

    watch: {
        currentStep(step) {
            window.scrollTo(0, 0);
            if (step === 5) {
                this.mainTitle =
                    this.lang === "es"
                        ? "Has finalizado la compra con éxito"
                        : "Has finalitzat la compra amb èxit";
            }
        }
    },

    created() {
        this.currentStep = this.stepProp;
        this.lang = window.appLocale;
    }
};
</script>

<style lang="scss">
.back-btn {
    position: absolute;
    left: 0;
    top: -10px;
    text-transform: lowercase;
}
.total {
    .font-input-amount {
        font-size: 1.875rem;
        font-family: "Aktiv-Extended", sans-serif;
        font-weight: bold;
    }
    .eur-icon {
        position: absolute;
        right: 15px;
        height: 100%;
    }
}
.do-pay {
    height: 46px !important;
    margin: auto;
}
.theme--light.v-input input,
.theme--light.v-input textarea {
    color: white;
}
.theme--light.v-icon {
    color: white;
}
.theme--light.v-select .v-select__selection--comma {
    color: white;
}
.v-application .ingresar-component a {
    color: white !important;
    &:hover {
        color: #ffdadd !important;
    }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    width: 100% !important;
}
/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.print-container {
    display: flex;
    margin-top: 2rem;
    justify-content: center;
    .print-button {
        background-color: #0fc0cc !important;
        color: white;
    }
}

.material-icons--arrow-left {
    margin-top: 3px;
}

.deposits-component {
    .steps {
        display: grid;
        grid-template-columns: 1fr;

        .step {
            grid-column: 1 / 2;
            grid-row: 1 / 2;
        }
    }
}
</style>
